import { useCallback } from "react";
import { useIntl } from "react-intl";
import { getLocalizedName, type LocalizedFields } from "@utils/localizedName";

export const useLocalizedName = () => {
  const { locale } = useIntl();
  return useCallback((item: LocalizedFields): string => getLocalizedName(item, locale), [locale]);
};
